<template>
  <v-container max-width="1200">
    <Breadcrumbs :items="breadcrumbsItems"/>
    <top-info-action
        :validBtn="hasAccess('/orders', 'POST')"
        principal-btn-title="Nueva orden"
        subtitle="Crea y visualiza tus ordenes para proveedor y almacén"
        title="Gestión de ordenes"
        @setDefaultPrimaryAction="createNewStore"
    />
    <orders-resume></orders-resume>
  </v-container>
</template>

<script>
import Breadcrumbs from "../components/Breadcrumbs";
import TopInfoAction from "../components/TopInfoAction.vue";
import moduleMixin from "@/mixins/moduleMixin";
import OrdersResume from "../components/orders/ordersResume.vue";

export default {
  name: "orders",
  mixins: [moduleMixin],
  components: {OrdersResume, TopInfoAction, Breadcrumbs},
  data: () => ({
    breadcrumbsItems: [
      {
        text: "Inicio",
        disabled: false,
        path: "/dashboard",
      },
      {
        text: "Gestion de ordenes",
        disabled: true,
        path: "/orders",
      },
    ],
  }),
  methods: {
    createNewStore() {
      this.$router.push({
        name: "CrudOrders",
        params: {crudAction: "create"},
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
